import {
    GetAuthenticatedVehiclesQueryParams,
    AuthenticatedVehicleGroupDto,
    VehicleGroupingQueryParameters,
} from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import { Options, setup } from "vue-class-component";
import { Emit, Prop, Vue } from "vue-property-decorator";
import { appCompanyStatusDialogModel } from "../app-company-status-dialog/app-company-status-dialog.model";
import "./app-vehicle-group-card.scss";
import { sessionModel } from "@/shared/state/session.model";
import format from "date-fns/format";
import { LocationQuery } from "vue-router";
import { useIsTablet } from "@/shared/composables/use-is-tablet";
import { getEnvValue } from "@/shared/models/environment";
@Options({})
export class AppVehicleGroupCardComponent extends Vue {
    @Prop()
    source?: "our-cars" | "my-favorites" | "vehicles-grouped" | "vehicles-details-swiper";

    @Prop({ required: true })
    filters!: LocationQuery;

    @Prop({ required: true })
    showIcon!: boolean;

    i18n = setup(useI18n);

    @Prop({ required: true })
    groupDto!: AuthenticatedVehicleGroupDto;

    arrowHover = false;
    vehicleInfoName = "";

    isTabletCtx = setup(useIsTablet);
    get isMobile() {
        return this.isTabletCtx.isTablet.matches;
    }

    get isAuthenticated() {
        return !!sessionModel.sessionDto.value;
    }

    get currency() {
        return "EUR";
    }

    formatDate(_date?: number | bigint): string {
        if (!_date) return "NO REG";
        const millisecondsSinceEpoch = Number(_date) * 24 * 60 * 60 * 1000;
        const date = new Date(millisecondsSinceEpoch);
        return format(new Date(Number(date)), "dd/MM/yyyy");
    }

    concatenateStrings(values: string[]): string {
        return values.join(", ");
    }

    @Emit("close-popup")
    routeToCarDetails(navigate: () => void, isSpecial = false) {
        if (isSpecial || !appCompanyStatusDialogModel.show()) {
            navigate();
        }
    }

    get getVehicleGroupingQueryParameters(): VehicleGroupingQueryParameters {
        return {
            grouping_mode: this.groupDto.grouping_mode.id,
            hashcode: this.groupDto.hashcode,
        };
    }

    mounted() {
        this.vehicleInfoName =
            this.concatenateStrings(this.groupDto.motorisations) +
            " " +
            this.concatenateStrings(this.groupDto.finishes);
    }

    get brandLabel() {
        return getEnvValue("BRAND_LABEL");
    }
}
